export default __webpack_public_path__ + "static/media/Sign-in-with-Google.8cbc70fe.png";